import { ReactNode } from "react";
import { AnimatedButton } from "../../animations";

interface GradientButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "primary" | "dashboard";
}

export default function GradientButton({ children, onClick, className, type, disabled, variant = "primary" }: GradientButtonProps) {
  return (
    <AnimatedButton
      onClick={onClick}
      className={className}
      variant={variant}
      type={type}
      disabled={disabled}
    >
      {children}
    </AnimatedButton>
  );
}

